module.exports = __webpack_public_path__ + "img/tool.019ecc2a.svg";